<template>
    <ul v-if="$state.invalidos" class="stats eleicoes-estatisticas-globais"
        :class="{ full: !$state.lite, all, euro: $state.tipo == 'europeias' }">
        <template v-if="$state.globais">
            <li v-if="!estrangeiro && $state.globais.freguesias">
                <div class="title">Freguesias apuradas</div>
                <div class="value">{{ $state.globais.freguesias.percentagem }}</div>
                <div class="info">{{ $state.globais.freguesias.apuradas }} de {{ frg }}</div>
            </li>
            <li v-if="(estrangeiro || all) && $state.globais.consulados">
                <div class="title">Consulados apurados</div>
                <div class="value">{{ $state.globais.consulados.percentagem }}</div>
                <div class="info">{{ $state.globais.consulados.apurados }} de {{ $state.globais.consulados.total }}
                </div>
            </li>
            <li v-if="mandatos && $state.tipo != 'europeias'">
                <div class="title">{{ mandatos.title }}</div>
                <div class="value">{{ mandatos.percentagem }}</div>
                <div class="info">{{ mandatos.description }}</div>
            </li>
        </template>
        <li v-if="$state.updated">
            <div class="title">Última atualização</div>
            <div class="value">{{ $state.updated.time }}</div>
            <div class="info">{{ $state.updated.date }}</div>
        </li>
    </ul>
</template>

<script>
import utils from '@/widgets/mapa/utils'

export default {
    props: {
        all: Boolean
    },
    computed: {
        mandatos() {
            if (!this.$state.globais || !this.$state.globais.mandatos) return;
            const clean = this.$state.tipo == 'legislativas' && (utils.isConcelho(this.$state.local) || utils.isFreguesia(this.$state.local));
            return {
                title: this.$state.globais.mandatos.title,
                percentagem: !clean ? this.$state.globais.mandatos.percentagem : 'N/A',
                description: !clean ? `${this.$state.globais.mandatos.atribuidos} de ${this.$state.globais.mandatos.total}` : ''
            };
        },
        estrangeiro() {
            return parseInt(`${this.$state.local || 0}`.charAt(0)) > 5 && `${this.$state.local}` != '990000';
        },
        frg() {
            return (!this.$state.globais || !this.$state.globais.freguesias ? null : (!parseInt(this.$state.globais.freguesias.total) ? this.$state.globais.freguesias.apuradas : this.$state.globais.freguesias.total)) || '';
        }
    }
}
</script>

<style lang="scss" scoped>
.stats {


    &.all {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    &.euro {
        grid-template-columns: 1fr 1fr;

        &.all {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }
}
</style>